import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.632 2.346a.75.75 0 0 1 .736 0l8 4.5a.75.75 0 0 1 .382.654v9a.75.75 0 0 1-.382.654l-8 4.5a.75.75 0 0 1-.736 0l-8-4.5a.75.75 0 0 1-.382-.654v-9a.75.75 0 0 1 .382-.654zm7.618 6.375v3.136l-3.611 1.986a.75.75 0 0 0-.389.657v3.811l-2.5 1.407v-7.283zm-8 3.714-6.5-3.714v2.872a.8.8 0 0 1 .15.072l3.5 2.2a.75.75 0 0 1 .35.635v3.811l2.5 1.407zm7.166-4.965L12 11.136 5.584 7.47l2.453-1.38a1 1 0 0 0 .09.061l3.5 2a.75.75 0 0 0 .745 0l3.5-2a1 1 0 0 0 .091-.061zM12 6.636 9.552 5.237 12 3.861l2.448 1.376zm7.25 9.425-2.5 1.407v-2.525l2.5-1.375zm-12-1.147v2.554l-2.5-1.407v-2.718z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }